"use client";

import { useEffect, useState } from 'react';
import { getApiUrl } from './api-url';

// Clé pour le stockage local
const VISIT_COUNTED_KEY = 'visualgrid_visit_counted';
// Durée de validité du comptage en millisecondes (ici 5 minutes)
const VISIT_TIMEOUT = 5 * 60 * 1000;

/**
 * Provider qui incrémente le compteur de visites une seule fois par période de temps
 */
export function VisitCounterProvider({ children }: { children: React.ReactNode }) {
  const [isEmbeddedInSynoptic, setIsEmbeddedInSynoptic] = useState(false);

  useEffect(() => {
    // Détecter si on est dans un iframe avec embed=synoptic
    const isInIframe = window.self !== window.top;
    const urlParams = new URLSearchParams(window.location.search);
    const embedParam = urlParams.get('embed');

    setIsEmbeddedInSynoptic(isInIframe && embedParam === 'synoptic');
  }, []);

  useEffect(() => {
    // Ne pas compter en mode Electron (offline) ou en mode embarqué
    const isElectron = typeof window !== 'undefined' && (window as any).electron;
    if (isElectron || isEmbeddedInSynoptic) {
      return;
    }

    // Fonction pour incrémenter le compteur de visites
    async function incrementVisit() {
      // Ne pas faire d'appel API en mode embarqué
      if (isEmbeddedInSynoptic) {
        return;
      }

      try {
        await fetch(getApiUrl('/api/grid-counters/visit'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        });

        // Enregistrer le timestamp actuel
        const currentTime = Date.now();
        localStorage.setItem(VISIT_COUNTED_KEY, currentTime.toString());
      } catch (error) {
        // console.error('Erreur lors de l\'incrémentation du compteur de visites:', error);
      }
    }

    // Vérifier si la visite a déjà été comptée récemment
    const lastVisitTime = localStorage.getItem(VISIT_COUNTED_KEY);
    const currentTime = Date.now();
    
    // Incrémenter le compteur si c'est la première visite ou si le délai est dépassé
    if (!lastVisitTime || (currentTime - parseInt(lastVisitTime)) > VISIT_TIMEOUT) {
      incrementVisit();
    }
  }, []);

  return children;
} 